import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import 'slick';
import 'Isotope';

export class enrichPartners {
    private $scope = $('#partnersDetailsNav');
    private $scopeSubGroup = $('.partnerWrapper');
    initCategoryDropdown(): any {
        let _self = this;
        let partnerCat = $('.enrich-partners-container .search-category');
        var getPartnerCat = $.Deferred();
        let getPartnerCategories: any = ($('[data-get-partner-categories]').data('get-partner-categories') != 'null' && $('[data-get-partner-categories]').data('get-partner-categories') != '' && $('[data-get-partner-categories]').data('get-partner-categories') != undefined) ? $('[data-get-partner-categories]').data('get-partner-categories').split('|') : [];
        if (getPartnerCategories.length > 0) {
            var listItems = "<option value=''> </option>";
            listItems += "<option value='all'>All</option>";
            for (var i = 0; i < getPartnerCategories.length; i++) {
                let categoryItem: any = getPartnerCategories[i].split(',');
                if (categoryItem.length > 0) {
                    if (categoryItem[0] != null && categoryItem[1] != null)
                        if (categoryItem[0].toLowerCase() != 'null' && categoryItem[1].toLowerCase() != 'null') {
                            listItems += "<option value='" + categoryItem[0] + "'>" + categoryItem[1] + "</option>";
                        }
                }
            }
            partnerCat.html(listItems);
            partnerCat.selectize({
                onInitialize: function () {
                    let $searchBtn: any = $('.searchRmSubmit');
                    partnerCat[0].selectize.setValue('all');
                    $searchBtn.trigger('click');
                },
                onFocus: function () {
                    partnerCat.parent().find('.booking-form--title').addClass('input-filled');
                    $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');
                },
                onChange: function () {
                    partnerCat.parent().find('.booking-form--title').addClass('input-filled');
                    $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');

                },
                onBlur: function () {
                    let partnerCatChange = partnerCat.find('option:selected').text();
                    if (partnerCatChange == '') {
                        partnerCat.parent().find('.booking-form--title').removeClass('input-filled');
                        $('.search-category.selectize-control.single .selectize-input').removeClass('select-filled');
                    } else {
                        partnerCat.parent().find('.booking-form--title').addClass('input-filled');
                        $('.search-category.selectize-control.single .selectize-input').addClass('select-filled');
                    }
                },
                sortField: 'text'
            });
        }
    }
    nav(): void {
        let $partnerNavList: any = $('#partnersDetailsNav li');
        let $partnerNav: any = $('#partnersDetailsNav');
        let _self = this;
        $partnerNav.find('li a').click(function () {
            $partnerNavList.removeClass('selected');
            $(this).parent().addClass('selected');
            let $selectGroup: any = $(this).attr('data-group');
            $partnerNav.find('#all-sub-items a').addClass('hide');
            $partnerNav.find('#all-sub-items a[data-group="' + $selectGroup + '"]').removeClass('hide');
            $partnerNav.find('#all-sub-items a[data-group="' + $selectGroup + '"]')[0].click();
            _self.initSubGroupButton();
            let items = $('.partnerWrapper').find('.button-group.sub-group');
            let itemWidth = items.find('a').width();
            let itemsGap = parseInt(items.find('a:visible').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            $(items).animate({
                scrollLeft: totalWidth
            }, 500);
            $('.partnerWrapper').find('.seq-sub-prev').fadeOut();
        });
    }

    init(): void {
        this.initShowMoreStores();
        this.handleGroupNextArrow();
        this.handleGroupPreviousArrow();
        let slidersGroup = this.$scope.find('#navbarNav');
        slidersGroup.each(function () {
            if ($(this).width() === this.scrollWidth) {
                $(this).parents("#partnersDetailsNav").find('button').hide();
            }
        });
        this.handleSubGroupNextArrow();
        this.handleSubGroupPreviousArrow();
        this.initSubGroupButton();
    }
    initSubGroupButton(): void {
        $(".partnerWrapper").find('button.seq-sub-next').show();
        let slidersSubGroup = this.$scopeSubGroup.find('.button-group.sub-group');
        slidersSubGroup.each(function () {
            if ($(this).width() === this.scrollWidth) {
                $(this).parents(".partnerWrapper").find('button').hide();
            }
        });
    }

    handleGroupNextArrow(): void {
        let nextArrow = this.$scope.find('.seq-next');

        nextArrow.click(function () {
            $(this).parents('#partnersDetailsNav').find('.seq-prev').fadeIn();
            let items = $(this).parents('#partnersDetailsNav').find('#navbarNav');
            let itemWidth = items.find('li').width();
            let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");
            $(items).animate({
                scrollLeft: $(items).scrollLeft() + scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                        $(this).fadeOut();
                    }
                });
        });
    }
    handleSubGroupNextArrow(): void {
        let nextArrow = this.$scopeSubGroup.find('.seq-sub-next');

        nextArrow.click(function () {
            $(this).parents('.partnerWrapper').find('.seq-sub-prev').fadeIn();
            let items = $(this).parents('.partnerWrapper').find('.button-group.sub-group');
            let itemWidth = items.find('a:visible').width();
            let itemsGap = parseInt(items.find('a:visible').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");
            $(items).animate({
                scrollLeft: $(items).scrollLeft() + scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                        $(this).fadeOut();
                    }
                });
        });
    }

    handleGroupPreviousArrow(): void {
        let prevArrow = this.$scope.find('.seq-prev');

        prevArrow.click(function () {
            $(this).parents('#partnersDetailsNav').find('.seq-next').fadeIn();
            let items = $(this).parents('#partnersDetailsNav').find('#navbarNav');
            let itemWidth = items.find('li').width();
            let itemsGap = parseInt(items.find('li').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");

            if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                let visibleItems = Math.floor(items.width() / totalWidth) * totalWidth;
                let partialVisibleWidth = items.width() % totalWidth;
                scrollWidth = visibleItems - partialVisibleWidth - itemsGap;
            }

            $(items).animate({
                scrollLeft: $(items).scrollLeft() - scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() <= 0) {
                        $(this).fadeOut();
                    }
                });


        });
    }
    handleSubGroupPreviousArrow(): void {
        let prevArrow = this.$scopeSubGroup.find('.seq-sub-prev');

        prevArrow.click(function () {
            $(this).parents('.partnerWrapper').find('.seq-sub-next').fadeIn();
            let items = $(this).parents('.partnerWrapper').find('.button-group.sub-group');
            let itemWidth = items.find('a').width();
            let itemsGap = parseInt(items.find('a').css('margin-inline-end'));
            let totalWidth = itemsGap + itemWidth;
            let scrollWidth = Math.floor(items.width() / totalWidth) * totalWidth;
            items.css("scroll-snap-type", "none");

            if (items.scrollLeft() + items.width() >= items.get(0).scrollWidth) {
                let visibleItems = Math.floor(items.width() / totalWidth) * totalWidth;
                let partialVisibleWidth = items.width() % totalWidth;
                scrollWidth = visibleItems - partialVisibleWidth - itemsGap;
            }

            $(items).animate({
                scrollLeft: $(items).scrollLeft() - scrollWidth
            }, 500,
                () => {
                    items.css("scroll-snap-type", "x mandatory");
                    if (items.scrollLeft() <= 0) {
                        $(this).fadeOut();
                    }
                });


        });
    }
    initShowMoreStores(): void {
        let $limitStores: any = $('.partner-details-container').attr('data-item--showonload');
        let $showItem: any = $('.show-partnerlogo--items .showing');
        let $totalStoresItem: any = $('.show-partnerlogo--items .total-destinations');
        let $showmoreStoresBtn: any = $('.btn-showmore-partners--logo');
        let $showmoreStoreText: any = $('.show-partnerlogo--items');
        let filterType: any = $('#isPartnersSearchResult').val();
        let $selectedCategory: any = $('.enrich-partners-container .search-category');
        let $noResultsMessage = $('.partner-noresults');
        let $totalStores: any;
        let $visiblePartners: any;
        let group: any = $('#navbarNav li.selected a').attr('data-group');
        let subGroup: any = $('.partnerWrapper .button-group.sub-group a.is-checked').attr('data-sub-group');
        if (filterType == 'No') {
            $('.partner-item').addClass('hidden');
            $showmoreStoresBtn.removeClass('hide');
            $noResultsMessage.addClass('hide');
            $showmoreStoreText.removeClass('hide');
            if (subGroup == '') {
                if ($('.partner-item.' + group).length == 0) {
                    $('.partner-item').each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $('.partner-item').length;
                    $visiblePartners = $('.partner-item' + ':visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
                else {
                    $('.partner-item.' + group).each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $('.partner-item.' + group).length;
                    $visiblePartners = $('.partner-item.' + group + ':visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
            }
            else {
                if ($('.partner-item.' + group).length == 0) {
                    $('.partner-item' + subGroup).each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $('.partner-item' + subGroup).length;
                    $visiblePartners = $('.partner-item' + subGroup + ':visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
                else {
                    $('.partner-item.' + group + subGroup).each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $('.partner-item.' + group + subGroup).length;
                    $visiblePartners = $('.partner-item.' + group + subGroup + ':visible').length;
                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
            }
        }
        else {
            $('.partner-item').addClass('hidden');
            $showmoreStoresBtn.removeClass('hide');
            $showmoreStoreText.removeClass('hide');
            $noResultsMessage.addClass('hide');
            let $filteredresults: any;
            if (subGroup == '') {
                if ($('.partner-item.' + group).length == 0) {
                    if ($selectedCategory.val() == 'all') {
                        $filteredresults = $('.partner-item');
                    }
                    else {
                        $filteredresults = $('.partner-item' + '*[data-category~="' + $selectedCategory.val() + '"]');
                    }
                }
                else {
                    if ($selectedCategory.val() == 'all') {
                        $filteredresults = $('.partner-item.' + group);
                    }
                    else {
                        $filteredresults = $('.partner-item.' + group + '*[data-category~="' + $selectedCategory.val() + '"]');
                    }
                }
                if ($filteredresults.length > 0) {
                    $noResultsMessage.addClass('hide');
                    $showmoreStoresBtn.removeClass('hide');
                    $showmoreStoreText.removeClass('hide');
                    $filteredresults.each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $filteredresults.length;
                    if ($('.partner-item.' + group).length == 0) {
                        $visiblePartners = $('.partner-item:visible').length;
                    }
                    else {
                        $visiblePartners = $('.partner-item.' + group + ':visible').length;
                    }

                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
                else {
                    $noResultsMessage.removeClass('hide');
                    $showmoreStoresBtn.addClass('hide');
                    $showmoreStoreText.addClass('hide');
                }
            }
            else {
                if ($('.partner-item.' + group).length == 0) {
                    if ($selectedCategory.val() == 'all') {
                        $filteredresults = $filteredresults = $('.partner-item' + subGroup);
                    }
                    else {
                        $filteredresults = $('.partner-item' + subGroup + '*[data-category~="' + $selectedCategory.val() + '"]');
                    }
                }
                else {
                    if ($selectedCategory.val() == 'all') {
                        $filteredresults = $filteredresults = $('.partner-item.' + group + subGroup);
                    }
                    else {
                        $filteredresults = $('.partner-item.' + group + subGroup + '*[data-category~="' + $selectedCategory.val() + '"]');
                    }
                }
                if ($filteredresults.length > 0) {
                    $noResultsMessage.addClass('hide');
                    $showmoreStoresBtn.removeClass('hide');
                    $showmoreStoreText.removeClass('hide');
                    $filteredresults.each(function (key: any, val: any) {
                        if (key < $limitStores) {
                            $(val).removeClass('hidden');
                        }
                    });
                    $totalStores = $filteredresults.length;
                    if ($('.partner-item.' + group).length == 0) {
                        $visiblePartners = $('.partner-item' + subGroup + ':visible').length;
                    }
                    else {
                        $visiblePartners = $('.partner-item.' + group + subGroup + ':visible').length;
                    }

                    $showItem.html($visiblePartners);
                    $totalStoresItem.html($totalStores);
                    if ($totalStores <= $visiblePartners) {
                        $showmoreStoresBtn.addClass('hide');
                    }
                }
                else {
                    $noResultsMessage.removeClass('hide');
                    $showmoreStoresBtn.addClass('hide');
                    $showmoreStoreText.addClass('hide');
                }

            }

        }
    }
    initShowMorebutton(): void {
        let $showmoreStoresBtn: any = $('.btn-showmore-partners--logo');
        let $showItem: any = $('.show-partnerlogo--items .showing');
        let $totalStoresItem: any = $('.show-partnerlogo--items .total-destinations');
        let $selectedCategory: any = $('.enrich-partners-container .search-category');
        $showmoreStoresBtn.on('click', (e: any) => {
            e.preventDefault();
            let $nextShowItems: any = $('.partner-details-container').attr('data-item--showeachclick');
            let filterType: any = $('#isPartnersSearchResult').val();
            let group: any = $('#navbarNav li.selected a').attr('data-group');
            let subGroup: any = $('.partnerWrapper .button-group.sub-group a.is-checked').attr('data-sub-group');
            if (filterType == 'No') {
                if (subGroup == '') {
                    let $totalStores: any;
                    let $shown: any;
                    if ($('.partner-item.' + group).length == 0) {
                        $totalStores = $('.partner-item').length;
                        $shown = $('.partner-item:visible').length + parseInt($nextShowItems);
                        if ($shown < $totalStores) {
                            $('.partner-item').each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            let $visiblePartners: any = $('.partner-item:visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $('.partner-item').each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $('.partner-item:visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }
                    else {
                        $totalStores = $('.partner-item.' + group).length;
                        $shown = $('.partner-item.' + group + ':visible').length + parseInt($nextShowItems);
                        if ($shown < $totalStores) {
                            $('.partner-item.' + group).each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            let $visiblePartners: any = $('.partner-item.' + group + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $('.partner-item.' + group).each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $('.partner-item.' + group + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }

                }
                else {
                    let $totalStores: any;
                    let $shown: any;
                    if ($('.partner-item.' + group).length == 0) {
                        $totalStores = $('.partner-item' + subGroup).length;
                        $shown = $('.partner-item' + subGroup + ':visible').length + parseInt($nextShowItems);
                        if ($shown < $totalStores) {
                            $('.partner-item' + subGroup).each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            let $visiblePartners: any = $('.partner-item' + subGroup + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $('.partner-ite.' + subGroup).each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $('.partner-item' + subGroup + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }
                    else {
                        $totalStores = $('.partner-item.' + group + subGroup).length;
                        $shown = $('.partner-item.' + group + subGroup + ':visible').length + parseInt($nextShowItems);
                        if ($shown < $totalStores) {
                            $('.partner-item.' + group + subGroup).each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            let $visiblePartners: any = $('.partner-item.' + group + subGroup + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $('.partner-item.' + group + subGroup).each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            let $visiblePartners: any = $('.partner-item.' + group + subGroup + ':visible').length;
                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }

                }
            }
            else {
                let $filteredresults: any;
                if (subGroup == '') {
                    if ($('.partner-item.' + group).length == 0) {
                        if ($selectedCategory.val() == 'all') {
                            $filteredresults = $('.partner-item');
                        }
                        else {
                            $filteredresults = $('.partner-item' + '*[data-category~="' + $selectedCategory.val() + '"]');
                        }
                    }
                    else {
                        if ($selectedCategory.val() == 'all') {
                            $filteredresults = $('.partner-item.' + group);
                        }
                        else {
                            $filteredresults = $('.partner-item.' + group + '*[data-category~="' + $selectedCategory.val() + '"]');
                        }
                    }

                    if ($filteredresults.length > 0) {
                        let $shown: any;
                        let $visiblePartners: any;
                        let $totalStores: any = $filteredresults.length;
                        if ($('.partner-item.' + group).length == 0) {
                            $shown = $('.partner-item:visible').length + parseInt($nextShowItems);
                        }
                        else {
                            $shown = $('.partner-item.' + group + ':visible').length + parseInt($nextShowItems);
                        }

                        if ($shown < $totalStores) {
                            $filteredresults.each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            if ($('.partner-item.' + group).length == 0) {
                                $visiblePartners = $('.partner-item:visible').length;
                            }
                            else {
                                $visiblePartners = $('.partner-item.' + group + ':visible').length;
                            }

                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $filteredresults.each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            if ($('.partner-item.' + group).length == 0) {
                                $visiblePartners = $('.partner-item:visible').length;
                            }
                            else {
                                $visiblePartners = $('.partner-item.' + group + ':visible').length;
                            }

                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }
                }
                else {
                    if ($('.partner-item.' + group).length == 0) {
                        if ($selectedCategory.val() == 'all') {
                            $filteredresults = $('.partner-item.' + subGroup);
                        }
                        else {
                            $filteredresults = $('.partner-item.' + subGroup + '*[data-category~="' + $selectedCategory.val() + '"]');
                        }
                    }
                    else {
                        if ($selectedCategory.val() == 'all') {
                            $filteredresults = $('.partner-item.' + group + subGroup);
                        }
                        else {
                            $filteredresults = $('.partner-item.' + group + subGroup + '*[data-category~="' + $selectedCategory.val() + '"]');
                        }
                    }

                    if ($filteredresults.length > 0) {
                        let $totalStores: any = $filteredresults.length;
                        let $shown: any;
                        let $visiblePartners: any;
                        if ($('.partner-item.' + group).length == 0) {
                            $shown = $('.partner-item' + subGroup + ':visible').length + parseInt($nextShowItems);
                        }
                        else {
                            $shown = $('.partner-item.' + group + subGroup + ':visible').length + parseInt($nextShowItems);
                        }

                        if ($shown < $totalStores) {
                            $filteredresults.each(function (key: any, val: any) {
                                if (key < $shown) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            if ($('.partner-item.' + group).length == 0) {
                                $visiblePartners = $('.partner-item' + subGroup + ':visible').length;
                            }
                            else {
                                $visiblePartners = $('.partner-item.' + group + subGroup + ':visible').length;
                            }

                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        } else {
                            $filteredresults.each(function (key: any, val: any) {
                                if (key < $totalStores) {
                                    $(val).removeClass('hidden');
                                }
                            });
                            $showmoreStoresBtn.addClass('hide');
                            if ($('.partner-item.' + group).length == 0) {
                                $visiblePartners = $('.partner-item' + subGroup + ':visible').length;
                            }
                            else {
                                $visiblePartners = $('.partner-item.' + group + subGroup + ':visible').length;
                            }

                            $showItem.html($visiblePartners);
                            $totalStoresItem.html($totalStores);
                        }
                    }
                }
            }
        });
    }
    initSubGroup(): void {
        let _self = this;
        $('.button-group').each(function (i: any, buttonGroup: any) {
            let $buttonGroup: any = $(buttonGroup);
            $buttonGroup.on('click', 'a', function () {
                $buttonGroup.find('.is-checked').removeClass('is-checked');
                $(this).addClass('is-checked');
                _self.initShowMoreStores();
            });
        });
    }
    searchFunctionality(): void {
        let $searchPartnersBtn: any = $('.enrich-partners-container .searchPartnersSubmit');
        let $clearSearchBtn: any = $('.enrich-partners-container .clearPartnerSearch');
        let $selectedCategory: any = $('.enrich-partners-container .search-category');
        let $partnerNav: any = $('#partnersDetailsNav');
        let _self = this;
        $searchPartnersBtn.on('click', (e: any) => {
            if ($selectedCategory.val() == 'all') {
                $('#isPartnersSearchResult').val('No');
            }
            else {
                $('#isPartnersSearchResult').val('Yes');
            }
            _self.initShowMoreStores();
        });
        $clearSearchBtn.on('click', (e: any) => {
            $('#isPartnersSearchResult').val('No');
            _self.initShowMoreStores();
            $selectedCategory[0].selectize.setValue('all');
            $partnerNav.find('li a')[0].click();
        });
        $partnerNav.find('li a')[0].click();
    }
}

let scope: Element = document.querySelector('.enrich-partners-container');
if (scope) {
    try {
        let enrichpartners = new enrichPartners();
        enrichpartners.initShowMorebutton();
        enrichpartners.initSubGroup();
        enrichpartners.initCategoryDropdown();
        enrichpartners.nav();
        enrichpartners.init();
        enrichpartners.searchFunctionality();
    } catch (e) { console.error(e); }
}
